/**
 * Web Style Import
 *
 */

import './style/dnb-tag.scss'
